import { clearCookies, clearStorage, signOut } from "../auth/utils";
import { useAuthContext } from "../context/AuthContext";

const useLog = () => {
  const auth = useAuthContext();

  const log = (message) => {
    process.env.REACT_APP_BASE_URL.includes("dev") && console.log(message);
  };

  const extendedLog = (message, className, functionName) => {
    process.env.REACT_APP_BASE_URL.includes("dev") &&
      console.log(`[${className}.js] - ${functionName} => `, message);
  };

  const errorLog = async (error, className, functionName, queryName) => {
    // Dev logging
    if (process.env.REACT_APP_BASE_URL.includes("dev")) {
      console.error(
        `[${className}.js] - ${functionName} ${queryName} Error => `,
        error
      );
    }

    // Prefer robust signals for auth failures
    const status = error?.response?.status;
    const code =
      error?.code ||
      error?.graphQLErrors?.[0]?.extensions?.code ||
      // try parse JSON message for code
      (() => {
        try {
          const msg = error?.message;
          const parsed = JSON.parse(msg);
          return parsed?.extensions?.code;
        } catch {
          return undefined;
        }
      })();

    const isAuthTransport = status === 401 || status === 403;
    const isAuthGraphQL =
      code === "UNAUTHENTICATED" ||
      code === "FORBIDDEN" ||
      code === "TOKEN_EXPIRED";

    // LAST-RESORT heuristic (keep for backward-compat, but prefer the checks above)
    const msgStr = JSON.stringify(error?.message || "").toLowerCase();
    const heuristicAuth =
      msgStr.includes("token is required") ||
      msgStr.includes("token verification error") ||
      msgStr.includes("token expired") ||
      msgStr.includes("unauthorized") ||
      msgStr.includes("invalid token") ||
      msgStr.includes("not valid user");

    if (isAuthTransport || isAuthGraphQL || heuristicAuth) {
      try {
        await signOut();
      } catch (_) {}
      try {
        clearStorage();
        clearCookies();
      } catch (_) {}
      try {
        auth.logout();
      } catch (_) {
        // Fallback: hard redirect if context not available
        window.location.href = "/login";
      }
    }
  };

  return { log, extendedLog, errorLog };
};

export default useLog;
